var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareBlackMobile = function SvgShareBlackMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "share-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54159",
    transform: "translate(-241 -170)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 21269",
    width: 29,
    height: 29,
    rx: 10,
    transform: "translate(241 170)",
    "data-fill": "a",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54158"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "noun-share-1037331",
    d: "M259.591 177a2.392 2.392 0 0 0-2.386 2.386 2.36 2.36 0 0 0 .139.788l-4.368 2.535a2.384 2.384 0 1 0 .005 3.58l4.362 2.53a2.362 2.362 0 0 0-.139.794 2.394 2.394 0 1 0 .458-1.4l-4.235-2.45a2.362 2.362 0 0 0 0-2.53l4.235-2.45a2.384 2.384 0 1 0 1.928-3.782Z"
  })))));
};
export default SvgShareBlackMobile;